import React from 'react';
import { classNames, layoutClassNames } from '../atoms';
import type { LayoutClassNameProps } from '../atoms';

export interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement>, LayoutClassNameProps {}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  className,
  children,
  role = 'group',
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}) => (
  <div
    className={classNames(
      'btn-group',
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    role={role}
    {...props}
  >
    {children}
  </div>
);

export default ButtonGroup;
